export default {
  SET_SELECTED_IMAGE: (state, selected) => {
    state.selected = selected;
  },
  SET_SELECTED_IMAGE_DETAIL: (state, selectedDetail) => {
    state.selectedDetail = { ...state.selectedDetail, ...selectedDetail };
  },
};
